import React, { ReactNode, useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { OrizontalResizer } from './Resizer';

const LayoutWrapper = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  margin-bottom: 6px;
  margin-top: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : 'inherit')};
`;

const Column = styled.div<{ width: number; overflow: string; padding?: string }>`
  flex: ${({ width }) => `0 0 ${width}%`};
  padding: ${({ padding }) => padding ?? '4px 24px 0px 14px'};
  overflow: ${({ overflow }) => overflow ?? 'auto'};
  height: 100%;
`;

interface TwoColumnsLayoutOwnProps {
  leftColumn: ReactNode;
  rightColumn: ReactNode;
  initialLeftWidth?: number;
}

const ResizableTwoColumnsLayout = ({ leftColumn, rightColumn, initialLeftWidth = 65 }: TwoColumnsLayoutOwnProps) => {
  const [leftWidth, setLeftWidth] = useState(initialLeftWidth);
  useEffect(() => {
    const savedWidth = localStorage.getItem('layout-column-width');
    if (savedWidth) {
      setLeftWidth(parseInt(savedWidth));
    }
  }, []);
  const startResizing = (e: React.MouseEvent) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = leftWidth;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const currentX = moveEvent.clientX;
      const diffX = currentX - startX;
      const newWidth = Math.max(Math.min(50, startWidth + (diffX / window.innerWidth) * 100), 20);
      setLeftWidth(newWidth);
      localStorage.setItem('layout-column-width', newWidth.toString());
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <LayoutWrapper>
      <Column width={leftWidth} overflow="hidden hidden">
        {leftColumn}
      </Column>
      <OrizontalResizer onMouseDown={startResizing} />
      <Column width={Math.max(100 - leftWidth, 0)} overflow="hidden scroll" padding="4px 44px 0px 24px">
        {rightColumn}
      </Column>
    </LayoutWrapper>
  );
};

export default ResizableTwoColumnsLayout;
